import { useCallback, useEffect, useRef, useState } from "react"

export function useTransientMessage(duration = 4000) {
	const [message, setMessage] = useState<string | null>(null)
	const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

	useEffect(() => () => {
		if (timerRef.current) {
			clearTimeout(timerRef.current)
		}
	}, [])

	const setTransientMessage = useCallback((nextMessage: string | null) => {
		if (timerRef.current) {
			clearTimeout(timerRef.current)
			timerRef.current = null
		}

		if (!nextMessage) {
			setMessage(null)
			return
		}

		setMessage(nextMessage)
		timerRef.current = setTimeout(() => {
			setMessage(null)
			timerRef.current = null
		}, duration)
	}, [duration])

	return [message, setTransientMessage] as const
}
